// extracted by mini-css-extract-plugin
export default {"title":"ChangePasswordModal_title__bYy-l"};